module.exports = require("/Users/ryzokuken/Code/osdc/blog/src/utils/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 502
// module chunks = 231608221292675